import {
  Assignment as ProjekteIcon,
  AssignmentTurnedIn as AufwaendeIcon,
} from '@mui/icons-material';
import { Box, LinearProgress } from '@mui/material';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { PlainEntityDetailsHeader } from '../../../components/plainEntityDetailsHeader/PlainEntityDetailsHeader';
import { RouterTabs } from '../../../components/routerTabs/RouterTabs';
import { AufwandTable } from '../../aufwand/list/AufwandTable';
import { useFindProjektByIdQuery } from '../api/projektApi';

import { ProjektDetails } from './details/ProjektDetails';

export const ProjektViewScreen: FC = () => {
  const { id } = useParams();
  const { data: projekt, isLoading } = useFindProjektByIdQuery(id as string);

  return (
    <Box>
      {isLoading && <LinearProgress sx={{ width: '100%' }} />}
      {projekt && (
        <>
          <PlainEntityDetailsHeader
            title={projekt.name}
            createdAt={projekt.creationDate}
            updatedAt={projekt.updateDate}
          />
          <RouterTabs
            tabs={[
              {
                index: true,
                path: 'projekt',
                label: 'Projekt',
                icon: <ProjekteIcon />,
                content: <ProjektDetails projekt={projekt} />,
              },
              {
                path: 'aufwaende',
                label: 'Aufwände',
                icon: <AufwaendeIcon />,
                content: (
                  <AufwandTable
                    initialFilterItems={{ projektId: { value: projekt.id, operator: 'equal' } }}
                    gridHeight={600}
                    stackProps={{ sx: { height: 600 } }}
                  />
                ),
              },
            ]}
          />
        </>
      )}
    </Box>
  );
};
